import type { PillarItem } from '../../../data/referenceGuides/types';

/**
 * Category cards. One component covers the Inventory guide's "Three Tiers",
 * Manufacturing's "Four Pillars", and Procurement's "Five Pillars" — the
 * column count is data, not a variant.
 *
 * The badge carries real content (PR, RFQ, ERP, WMS), not a decorative icon.
 * That is what keeps this off the "icon in a coloured circle" slop pattern.
 */
/**
 * Column counts are capped below the declared value on purpose. Inside a guide
 * the content column is ~880px (max-w-6xl minus the 220px TOC rail), so five
 * cards across leaves ~176px each and every title wraps to two lines. Three
 * across reads properly; the fifth card wrapping to a second row is fine.
 */
const COLUMN_CLASS: Record<3 | 4 | 5, string> = {
  3: 'sm:grid-cols-2 lg:grid-cols-3',
  4: 'sm:grid-cols-2 xl:grid-cols-4',
  5: 'sm:grid-cols-2 lg:grid-cols-3'
};
const EMPHASIS: Record<'accent' | 'warn' | 'default', {
  badge: string;
  layer: string;
}> = {
  accent: {
    badge: 'bg-guide-procurement/15 text-guide-procurement',
    layer: 'text-guide-procurement'
  },
  warn: {
    badge: 'bg-magenta-hot/15 text-magenta-hot',
    layer: 'text-magenta-hot'
  },
  default: {
    badge: 'bg-violet-link/15 text-violet-link',
    layer: 'text-violet-link'
  }
};
export function PillarsBlock({
  columns,
  items
}: {
  columns: 3 | 4 | 5;
  items: PillarItem[];
}) {
  return <ul className={`grid grid-cols-1 ${COLUMN_CLASS[columns]} gap-4 list-none p-0`} data-id="element-320" data-mp="2n313hjpmcrxf">
      {items.map(item => {
      const e = EMPHASIS[item.emphasis ?? 'default'];
      return <li key={item.tag} className="rounded-xl border border-white/[0.08] bg-white/[0.02] p-5 flex flex-col" data-id="element-321" data-mp="2w4itbtstw7zb">
            <span className={`w-10 h-9 rounded-lg ${e.badge} flex items-center justify-center text-xs font-bold tracking-wide mb-4`} data-id="element-322" data-mp="2s2e211purnfu">
              {item.tag}
            </span>
            <p className="text-white font-semibold text-base mb-1" data-id="element-323" data-mp="7conyqwz45o7">{item.title}</p>
            <p className={`${e.layer} text-sm font-medium mb-3`} data-id="element-324" data-mp="7era2zv09enn">{item.layer}</p>
            <p className="text-white/55 text-sm leading-relaxed" data-id="element-325" data-mp="306n4zxtg2dw3">{item.body}</p>
          </li>;
    })}
    </ul>;
}